module.exports = {"en":{"title":"EVE Online Launcher"},"de":{"title":"EVE Online Launcher"},"fr":{"title":"Lanceur EVE Online"},"ru":{"title":"EVE Online Программа запуска"},"ja":{"title":"EVE Online Launcher"},"zh":{"title":"星战前夜：克隆崛起启动器"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/TitleBar/title-bar.json
// module id = 964
// module chunks = 0